import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
};
export const Header = (props: Props) => {
  const { className } = props;
  return (
    <header className={cn("relative mx-auto mt-13 mb-16 flex", className)}>
      <img src="/new-public/text-logo.svg" alt="Resonar" className="w-65.5" />
      <img
        src="/new-public/message-bubble.png"
        alt="message bubble"
        className="absolute -right-8 -bottom-6.5 h-9 w-38"
      />
    </header>
  );
};
